<ion-card class="ion-no-margin">
  <ion-list class="ion-no-padding">
    <ion-radio-group 
      [value]="selectedOption" 
      (ionChange)="handleRadioChange($event)"
      class="appointment-radio-group"
    >
      <ion-item class="ion-margin ion-no-padding">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="auto">
              <aaa-icon name="time-outline" color="medium" size="small" class="margin-right-8"></aaa-icon>
            </ion-col>
            <ion-col>
              <aaa-text size="footnote" color="text" weight="semibold" class="margin-bottom-4" i18n>Request Assistance Now</aaa-text>
              <aaa-text size="caption" color="subtle" i18n>Request a service and go</aaa-text>
            </ion-col>
            <ion-col size="auto" class="radio-container">
              <ion-radio 
                [value]="AppointmentOption.NOW"
                id="option-now"
                [tabIndex]="0"
                class="drr-radio-circle"
              ></ion-radio>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>

      <ion-item class="ion-margin ion-no-padding" lines="none">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col size="auto">
              <aaa-icon name="calendar-event" color="medium" size="small" class="margin-right-8"></aaa-icon>
            </ion-col>
            <ion-col>
              <aaa-text size="footnote" color="text" weight="semibold" class="margin-bottom-4" i18n>Schedule Assistance For Later</aaa-text>
              @if (appointmentSelected) {
                <aaa-text size="caption" color="subtle">{{ formattedAppointmentTime }}</aaa-text>
              } @else {
                <aaa-text size="caption" color="subtle" i18n>Reserve for extra peace of mind</aaa-text>
              }
            </ion-col>
            <ion-col size="auto" class="radio-container">
              <ion-radio 
                [value]="AppointmentOption.LATER"
                id="option-later"
                [tabIndex]="0"
                class="drr-radio-circle"
              ></ion-radio>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-radio-group>
  </ion-list>
  @if (appointmentSelected) {
    <ion-grid class="ion-margin-horizontal ion-no-padding change-schedule-grid">
      <ion-row>
        <ion-col>
          <a (click)="handleChangeSchedule()">
            <aaa-text size="caption" color="subtle" color="primary" display="inline" i18n>Change Schedule</aaa-text>
          </a>
        </ion-col>
      </ion-row>
    </ion-grid>
  }  
</ion-card>